// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__S7KxB","item":"PaymentsMobile_item__1pktj","label":"PaymentsMobile_label__2ebG5","amount":"PaymentsMobile_amount__19Nvb"};